__turbopack_context__.v({
  "Button": "SearchForm-module-scss-module__luz26G__Button",
  "Inner": "SearchForm-module-scss-module__luz26G__Inner",
  "Input": "SearchForm-module-scss-module__luz26G__Input",
});
